import { axiosPrivateInstance } from 'libs/axios';
import { GET_ALL_PRODUCT_ATTRIBUTES_BY_GROUP_ID } from 'utils/serviceUrls';

const getAllProductAttributesByGroupIdService = async (params: any) => {
	const paramData = {
		url: 'string',
		agent: 'string',
		encProductGroupId: params,
	};
	// eslint-disable-next-line no-return-await
	return await axiosPrivateInstance
		.post(GET_ALL_PRODUCT_ATTRIBUTES_BY_GROUP_ID, paramData)
		.then((response: any) => {
			return response;
		})
		.catch(() => {
			return false;
		});
};

export default getAllProductAttributesByGroupIdService;
